var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"options":_vm.currencies,"reduce":function (currency) { return currency.code; },"label":"code","value":_vm.userCurrency,"clearable":false},on:{"input":_vm.changeCurrency}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }